import { render, staticRenderFns } from "./PageFourElite.vue?vue&type=template&id=047ea6b4&scoped=true"
import script from "./PageFourElite.vue?vue&type=script&lang=js"
export * from "./PageFourElite.vue?vue&type=script&lang=js"
import style0 from "./PageFourElite.vue?vue&type=style&index=0&id=047ea6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ea6b4",
  null
  
)

export default component.exports